<template>
    <div>
        <div class="container">
            <el-container>
                <el-main>
                    <div class="container-box">
                        <div>
                            <div class="container-main">
                                <div class="container-main-left">
                                    <ul>
                                        <li v-for="(item, index) in list" :class="{active:activeIndex === index }"
                                            @click="check(index)">
                                            {{item.name}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="container-main-right">
                                    <template v-if="activeIndex === 0">
                                        <div style="  overflow-y: auto;border-bottom:1px solid #ebeef5;">
                                            <el-table
                                                    key="tableData"
                                                    border
                                                    :data="tableData.row">
                                                <el-table-column
                                                        label="序号"
                                                        type="index"
                                                        width="55">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="name"
                                                        label="任务名称">
                                                </el-table-column>
                                                <el-table-column
                                                        label="飞行日期">
                                                    <template slot-scope="scope">
                                                        <div v-if="scope.row.upTime">
                                                            {{scope.row.upTime.slice(0,16)}}
                                                        </div>
                                                        <div v-else>
                                                            暂无数据
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="图片数量"
                                                        prop="img_number"
                                                >
                                                </el-table-column>

                                                <el-table-column
                                                        label="操作"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <div @click="goRouter(0,scope.row.id)" style="display: flex">
                                                            <el-button type="text" size="small">开始建模</el-button>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </template>
                                    <template v-if="activeIndex === 1">
                                        <div style="  overflow-y: auto;border-bottom:1px solid #ebeef5;">
                                            <el-table

                                                    border
                                                    :data="tableData1.row">
                                                <el-table-column
                                                        label="序号"
                                                        type="index"
                                                        width="55">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="name"
                                                        label="任务名称">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="modelName"
                                                        label="模型命名">
                                                </el-table-column>
                                                <el-table-column
                                                        label="是否审核">
                                                    <template slot-scope="scope">
                                                        <div v-if="scope.row.audit !==0 && scope.row.audit !== '' ">
                                                            教师未审核,可以更改
                                                        </div>
                                                        <div v-else>
                                                            教师已审核,无法更改
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="scope"
                                                        label="得分">
                                                </el-table-column>
                                                <el-table-column
                                                        label="操作"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <div style="display: flex">
                                                            <el-button type="text" size="small"
                                                                       @click="select(scope.row)">查看模型
                                                            </el-button>
                                                            <el-button :disabled="scope.row.audit ==0  || scope.row.audit == '' " type="text" size="small"
                                                                       @click="goRouter1(scope.row)">
                                                                任务完成
                                                            </el-button>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </template>
                                    <div v-if="activeIndex === 2" style="height: 100%">
                                        <iframe style="width: 100%;height: 100%;"
                                                src="../../../../../static/video/wrj.mp4"
                                                frameborder="0"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>

            </el-container>
        </div>
    </div>
</template>

<script>
    //中  失败 成功
    export default {
        data() {
            return {
                tableData: [],
                tableData1: [],
                activeIndex: 0,
                list: [
                    {name: '我要建模'},
                    {name: '模型列表'},
                    {name: '视频教学'},
                ]
            }
        },
        methods: {
            select(row) {
                console.log(row);
                this.$alert('请确认，新建窗口未被浏览器自动拦截！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        let data = {
                            optionIds: '35',
                            taskId: sessionStorage.AltizureId
                        }
                        this.$axios.post(this.URL.uUserTask.select, data).then(res => {

                            if (res.status === 200) {
                                this.optionIds = []
                                if (row.name.indexOf('山地')) {
                                    if (row.scope < 60) {
                                        window.open('#/webglTest?model3D=' + 'GHcP4EaKC90AMV963z7HUpp0S4ZS7hpJ');
                                    } else if (row.scope < 70) {
                                        window.open('#/webglTest?model3D=' + 'LVB481B7d11W2GERtOc5wokcAfJX3kKi');
                                    } else if (row.scope < 80) {
                                        window.open('#/webglTest?model3D=' + 'O7o87jr11J2LM0prq2I3YiQ52b6DWTd7');
                                    } else if (row.scope < 90) {
                                        window.open('#/webglTest?model3D=' + 'I0193ofMX48y9L1IxS8VfZCrH0J8D6N9');
                                    } else if (row.scope < 100) {
                                        window.open('#/webglTest?model3D=' + 'K2o6YQm3c9l8f7QBnntuE2O6A12359s3');
                                    }
                                } else {
                                    if (row.scope < 60) {
                                        window.open('#/webglTest?model3D=' + '8chmdWlYCr3rpY5iteQJ96lEXO362Ur5');
                                    } else if (row.scope < 70) {
                                        window.open('#/webglTest?model3D=' + '1K78s0d5A0sTaqML7E2R0Ph5MmRFyhiU');
                                    } else if (row.scope < 80) {
                                        window.open('#/webglTest?model3D=' + '2FJGqiF6Al8DHtXr2roMRJxQ9kdiLsK3');
                                    } else if (row.scope < 100) {
                                        window.open('#/webglTest?model3D=' + '3THS4IdY8yIRQS4vj4Ov9GDZp1ZYsy5g');
                                    }
                                }

                            }
                        }).catch(err => {

                        })
                    }
                });
            },


            check(index) {
                this.activeIndex = index
                if (index === 1) {
                    this.getModelingList()
                } else if (index === 2) {
                    this.getModelList()
                }
            },
            goRouter1(item) {
                let data = {
                    optionId: 34,
                    taskId: 4,
                };
                this.$axios.post(this.URL.uUserTask.select, data).then(res => {
                    this.$notify({
                        title: '成功',
                        message: '任务完成',
                        type: 'success',
                    });
                    this.getModelingList()
                });
            },
            goRouter(index, id) {
                sessionStorage.setItem('taskId', id)
                this.goMain('/psPlugin')
            },
            //我要建模
            getModelingList() {
                let params = {
                    page: 1,
                    size: 10,
                }
                this.$axios.get(this.URL.uUserTask.modelingList, {params}).then(res => {
                    if (res.status === 200) {
                        this.tableData = res.data
                    }
                })
            },


            //模型列表
            getModelList() {
                let params = {
                    page: 1,
                    size: 10,
                }
                this.$axios.get(this.URL.uUserTask.modelList, {params}).then(res => {
                    if (res.status === 200) {
                        this.tableData1 = res.data
                    }
                })
            }
        },
        created() {
            this.getModelingList()
            this.getModelList()
        }
    }
</script>

<style lang="less" scoped>
    .el-container {
        height: 100vh;
    }

    .container-header {
        position: relative;
        width: 90%;

        div {
            position: absolute;
            right: 0;
            width: 100px;
        }
    }

    .container-box {
        width: 93%;
        margin-top: 7vh;
        position: relative;
        height: inherit;
        margin: 7vh auto;

        .container-main {
            display: flex;

            .container-main-left {
                width: 90px;

                li {
                    height: 15vh;
                    text-align: center;
                    padding: 70px 15px;
                    font-size: 18px;
                    font-weight: 700;
                    color: #333333;
                    border: 1px solid #333333;
                }
            }

            .container-main-right {
                width: 100%;
                overflow-y: hidden;
                border: 1px solid #ebeef5;
            }
        }

        .el-main {
            height: inherit;

        }
    }

    .active {
        background-color: #409EFF;
    }

</style>



// WEBPACK FOOTER //
// src/views/main/dataCenter/modeling/modeling.vue